(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const hasPdpV2 = () => Boolean(document.querySelector("product-info[data-thom-product-v2='rain-suit']"));

  const initGallery = (scope = document) => {
    scope.querySelectorAll('[data-thom-pdp-gallery]').forEach((gallery) => {
      if (gallery.dataset.thomInitialized === 'true') return;
      gallery.dataset.thomInitialized = 'true';

      const mainImage = gallery.querySelector('[data-thom-gallery-main]');
      const dialog = gallery.querySelector('[data-thom-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-thom-gallery-dialog-image]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-thom-gallery-thumb]'));
      const variantThumb = gallery.querySelector('[data-thom-gallery-variant-thumb]');
      const variantThumbImage = variantThumb?.querySelector('img');
      const productInfo = gallery.closest('product-info');
      const previous = gallery.querySelector('[data-thom-gallery-previous]');
      const next = gallery.querySelector('[data-thom-gallery-next]');
      const open = gallery.querySelector('[data-thom-gallery-open]');
      let activeIndex = 0;
      let activeVariantMediaId = variantThumb?.dataset.mediaId || '';

      if (!mainImage || !thumbs.length) return;

      const activate = (nextIndex, moveFocus = false, scrollThumb = true) => {
        activeIndex = (nextIndex + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        const src = thumb.dataset.imageSrc;
        const alt = thumb.dataset.imageAlt || '';

        mainImage.src = src;
        mainImage.alt = alt;
        if (dialogImage) {
          dialogImage.src = src;
          dialogImage.alt = alt;
        }

        thumbs.forEach((item, index) => {
          const isActive = index === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (scrollThumb) {
          thumb.scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }

        if (moveFocus) thumb.focus();
      };

      const updateVariantMedia = (variant) => {
        const media = variant?.featured_media?.preview_image;
        const mediaId = variant?.featured_media?.id;
        if (!variantThumb || !media?.src || !mediaId || String(mediaId) === activeVariantMediaId) return;

        const color = variant.option1 || variant.options?.[0] || '';
        const productTitle = productInfo?.querySelector('variant-selects')?.dataset.productTitle || 'Product';
        const alt = color ? `${productTitle} in ${color}` : productTitle;

        variantThumb.dataset.imageSrc = media.src;
        variantThumb.dataset.imageAlt = alt;
        variantThumb.dataset.mediaId = String(mediaId);
        variantThumb.setAttribute('aria-label', color ? `Show ${color} product image` : 'Show selected product image');

        if (variantThumbImage) variantThumbImage.src = media.src;
        activeVariantMediaId = String(mediaId);
        activate(thumbs.indexOf(variantThumb), false, false);
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activate(index));
        thumb.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') activate(0, true);
          if (event.key === 'End') activate(thumbs.length - 1, true);
          if (event.key === 'ArrowLeft') activate(index - 1, true);
          if (event.key === 'ArrowRight') activate(index + 1, true);
        });
      });

      previous?.addEventListener('click', () => activate(activeIndex - 1));
      next?.addEventListener('click', () => activate(activeIndex + 1));
      open?.addEventListener('click', () => {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== productInfo?.dataset.section) return;
          updateVariantMedia(data.variant);
        });
      }
    });
  };

  const initBenefits = (scope = document) => {
    scope.querySelectorAll('[data-thom-benefits]').forEach((benefits) => {
      if (benefits.dataset.thomInitialized === 'true') return;
      benefits.dataset.thomInitialized = 'true';

      const tabs = Array.from(benefits.querySelectorAll('[data-thom-benefit-tab]'));
      const panels = Array.from(benefits.querySelectorAll('[data-thom-benefit-panel]'));
      const interval = Number(benefits.dataset.interval) || 5000;
      let activeIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active')));
      let timer = null;
      let paused = false;

      if (!tabs.length || tabs.length !== panels.length) return;

      panels.forEach((panel, index) => {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      });

      const stop = () => {
        window.clearTimeout(timer);
        timer = null;
      };

      const schedule = () => {
        stop();
        if (paused || reduceMotion.matches) return;
        timer = window.setTimeout(() => activate(activeIndex + 1), interval);
      };

      const activate = (nextIndex, moveFocus = false) => {
        activeIndex = (nextIndex + tabs.length) % tabs.length;

        tabs.forEach((tab, index) => {
          const isActive = index === activeIndex;
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel, index) => {
          const isActive = index === activeIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        void tabs[activeIndex].offsetWidth;
        tabs[activeIndex].classList.add('is-active');
        if (moveFocus) tabs[activeIndex].focus();
        schedule();
      };

      const setPaused = (value) => {
        paused = value;
        benefits.dataset.paused = value ? 'true' : 'false';
        if (value) stop();
        else schedule();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('pointerenter', () => activate(index));
        tab.addEventListener('focus', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') activate(0, true);
          if (event.key === 'End') activate(tabs.length - 1, true);
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') activate(index - 1, true);
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') activate(index + 1, true);
        });
      });

      benefits.addEventListener('pointerenter', () => setPaused(true));
      benefits.addEventListener('pointerleave', () => setPaused(false));
      benefits.addEventListener('focusin', () => setPaused(true));
      benefits.addEventListener('focusout', (event) => {
        if (!benefits.contains(event.relatedTarget)) setPaused(false);
      });

      activate(activeIndex);
    });
  };

  const initFit = (scope = document) => {
    scope.querySelectorAll('[data-thom-fit-form]').forEach((form) => {
      if (form.dataset.thomInitialized === 'true') return;
      form.dataset.thomInitialized = 'true';

      const input = form.querySelector('[data-thom-fit-input]');
      const error = form.querySelector('[data-thom-fit-error]');
      const result = form.querySelector('[data-thom-fit-result]');
      const dataElement = form.querySelector('[data-thom-fit-data]');
      const unitButtons = Array.from(form.querySelectorAll('[data-thom-fit-unit]'));
      if (!input || !error || !result || !dataElement || unitButtons.length !== 2) return;

      let sizes;
      try {
        sizes = JSON.parse(dataElement.textContent);
      } catch (parseError) {
        return;
      }

      let unit = 'cm';
      let canonicalCm = null;

      const currentNumber = () => {
        if (!input.value.trim()) return null;
        const number = Number(input.value);
        return Number.isFinite(number) ? number : Number.NaN;
      };

      const syncCanonical = () => {
        const number = currentNumber();
        if (number === null || Number.isNaN(number)) {
          canonicalCm = null;
          return;
        }
        canonicalCm = unit === 'cm' ? number : number * 2.54;
      };

      const setError = (message) => {
        error.textContent = message;
        error.hidden = !message;
        input.setAttribute('aria-invalid', message ? 'true' : 'false');
        if (message) result.hidden = true;
      };

      const rangeText = (range) => `${range[0]}–${range[1]} cm`;

      const renderSingle = (size, measurement) => {
        result.innerHTML = `
          <h4>Recommended starting size</h4>
          <strong class="thom-pdp-v2-fit__result-size">${size.size}</strong>
          <p>${size.size} is the closest starting size based on a ${measurement} cm back length.</p>
          <h4>Confirm the fit</h4>
          <ul>
            <li>Neck: ${rangeText(size.neck)}</li>
            <li>Chest: ${rangeText(size.chest)}</li>
          </ul>
          <p>Check that your dog’s neck and chest also fall within these ranges before ordering.</p>
        `;
        result.hidden = false;
      };

      const renderBetween = (lower, upper) => {
        result.innerHTML = `
          <h4>Between sizes</h4>
          <strong class="thom-pdp-v2-fit__result-size">${lower.size} / ${upper.size}</strong>
          <p>Your dog’s back length falls between our ${lower.size} and ${upper.size} size references.</p>
          <h4>Check neck &amp; chest</h4>
          <ul>
            <li>${lower.size}: Neck ${rangeText(lower.neck)}, Chest ${rangeText(lower.chest)}</li>
            <li>${upper.size}: Neck ${rangeText(upper.neck)}, Chest ${rangeText(upper.chest)}</li>
          </ul>
          <p>Compare your dog’s neck and chest measurements before ordering. If you’re still unsure, send us their measurements for a Free Fit Check.</p>
        `;
        result.hidden = false;
      };

      const renderOutside = () => {
        result.innerHTML = `
          <h4>No recommendation</h4>
          <strong class="thom-pdp-v2-fit__result-size">Let’s check together.</strong>
          <p>We couldn’t confidently recommend a size. Your dog’s back length falls outside the range covered by this size chart.</p>
          <p>Send us their back, neck and chest measurements and we’ll help you check the closest option.</p>
        `;
        result.hidden = false;
      };

      input.addEventListener('input', () => {
        syncCanonical();
        if (!error.hidden) setError('');
      });

      unitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextUnit = button.dataset.thomFitUnit;
          if (nextUnit === unit) return;
          syncCanonical();
          unit = nextUnit;
          unitButtons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          if (canonicalCm !== null) {
            const displayValue = unit === 'cm' ? canonicalCm : canonicalCm / 2.54;
            input.value = Number(displayValue.toFixed(1)).toString();
          }
        });
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const number = currentNumber();
        if (number === null) {
          setError('Enter your dog’s back length.');
          return;
        }
        if (Number.isNaN(number) || number <= 0) {
          setError('Enter a valid back length.');
          return;
        }

        syncCanonical();
        setError('');
        const cm = canonicalCm;
        if (cm < sizes[0].back || cm > sizes[sizes.length - 1].back) {
          renderOutside();
          return;
        }

        for (let index = 0; index < sizes.length - 1; index += 1) {
          const midpoint = (sizes[index].back + sizes[index + 1].back) / 2;
          if (Math.abs(cm - midpoint) < 0.0001) {
            renderBetween(sizes[index], sizes[index + 1]);
            return;
          }
        }

        const closest = sizes.reduce((best, candidate) =>
          Math.abs(candidate.back - cm) < Math.abs(best.back - cm) ? candidate : best,
        );
        renderSingle(closest, Number(cm.toFixed(1)).toString());
      });
    });

    const chart = document.querySelector('[data-thom-fit-chart]');
    if (!chart || chart.dataset.thomInitialized === 'true') return;
    chart.dataset.thomInitialized = 'true';

    document.querySelectorAll('[data-thom-fit-chart-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (typeof chart.showModal === 'function') chart.showModal();
        else chart.setAttribute('open', '');
      });
    });

    chart.addEventListener('click', (event) => {
      if (event.target === chart) chart.close();
    });
  };

  const initReviews = (scope = document) => {
    scope.querySelectorAll('[data-thom-pdp-reviews]').forEach((reviews) => {
      if (reviews.dataset.thomInitialized === 'true') return;
      reviews.dataset.thomInitialized = 'true';

      const viewport = reviews.querySelector('[data-thom-reviews-viewport]');
      const cards = Array.from(reviews.querySelectorAll('[data-thom-review-card]'));
      const previous = reviews.querySelector('[data-thom-reviews-previous]');
      const next = reviews.querySelector('[data-thom-reviews-next]');
      const pagination = reviews.querySelector('[data-thom-reviews-pagination]');
      const status = reviews.querySelector('[data-thom-reviews-status]');
      if (!viewport || !cards.length || !pagination) return;

      let activeIndex = 0;
      let timer = null;
      let paused = false;
      let dragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let scrollFrame = null;

      const cardStep = () => {
        if (cards.length < 2) return cards[0].getBoundingClientRect().width;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      };

      const dots = cards.map((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show customer review ${index + 1}`);
        dot.addEventListener('click', () => scrollToIndex(index));
        pagination.append(dot);
        return dot;
      });

      const update = (index) => {
        activeIndex = Math.max(0, Math.min(cards.length - 1, index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        if (status) status.textContent = `Customer review ${activeIndex + 1} of ${cards.length}`;
      };

      const scrollToIndex = (index) => {
        const nextIndex = (index + cards.length) % cards.length;
        viewport.scrollTo({
          left: cards[nextIndex].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
        update(nextIndex);
      };

      const stop = () => {
        window.clearTimeout(timer);
        timer = null;
      };

      const schedule = () => {
        stop();
        if (paused || reduceMotion.matches) return;
        timer = window.setTimeout(() => {
          scrollToIndex(activeIndex + 1);
          schedule();
        }, 6500);
      };

      const setPaused = (value) => {
        paused = value;
        if (value) stop();
        else schedule();
      };

      previous?.addEventListener('click', () => {
        scrollToIndex(activeIndex - 1);
        schedule();
      });
      next?.addEventListener('click', () => {
        scrollToIndex(activeIndex + 1);
        schedule();
      });

      viewport.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(viewport.scrollLeft / Math.max(1, cardStep()));
          update(index);
          scrollFrame = null;
        });
      }, { passive: true });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
        setPaused(true);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        viewport.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      });

      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        scrollToIndex(Math.round(viewport.scrollLeft / Math.max(1, cardStep())));
        setPaused(false);
      };

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      reviews.addEventListener('pointerenter', () => setPaused(true));
      reviews.addEventListener('pointerleave', () => setPaused(false));
      reviews.addEventListener('focusin', () => setPaused(true));
      reviews.addEventListener('focusout', (event) => {
        if (!reviews.contains(event.relatedTarget)) setPaused(false);
      });

      update(0);
      schedule();
    });
  };

  const initFaq = (scope = document) => {
    scope.querySelectorAll('[data-thom-faq]').forEach((faq) => {
      if (faq.dataset.thomInitialized === 'true') return;
      faq.dataset.thomInitialized = 'true';
      const buttons = Array.from(faq.querySelectorAll('[data-thom-faq-button]'));

      const close = (button) => {
        const answer = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', 'false');
        const icon = button.querySelector('i');
        if (icon) icon.textContent = '+';
        if (answer) answer.hidden = true;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
          buttons.forEach(close);
          if (!shouldOpen) return;
          const answer = document.getElementById(button.getAttribute('aria-controls'));
          button.setAttribute('aria-expanded', 'true');
          const icon = button.querySelector('i');
          if (icon) icon.textContent = '−';
          if (answer) answer.hidden = false;
        });
      });
    });
  };

  const init = (scope = document) => {
    if (!hasPdpV2()) return;
    initGallery(scope);
    initBenefits(scope);
    initFit(scope);
    initReviews(scope);
    initFaq(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
